import { render, staticRenderFns } from "./UiPaginationControls.vue?vue&type=template&id=004d34c2"
import script from "./UiPaginationControls.vue?vue&type=script&lang=ts"
export * from "./UiPaginationControls.vue?vue&type=script&lang=ts"
import style0 from "./UiPaginationControls.vue?vue&type=style&index=0&id=004d34c2&prod&scopped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports